import { createAction } from '@reduxjs/toolkit';
import { initialValue } from '../../helperContext';
import { AffectationSearch } from '../../BaselineAffectationContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const updateAffectationSearchAction = createAction(
  BaselineAffectationType.UpdateSearch,
  (field: keyof AffectationSearch, value: any) => ({
    payload: { field, value },
  })
);

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.UpdateSearch:
      return {
        ...state,
        search: {
          ...state.search,
          [action.payload.field]: action.payload.value,
        },
      };
    default:
      return state;
  }
};
